var path = '/components/directives/customfield/color-picker.tpl.html';
var html = "<label for=\"{{name}}\" ng-if=\"field.definition.name\">{{::field.definition.name}} <span ng-if=\"field.definition.required\">*</span></label>\n<p class=\"help-text\" ng-if=\"field.definition.help\">{{::field.definition.help}}</p>\n<color-picker ng-model=\"field.ngModel\" options=\"{format: 'hexString',alpha: false}\"></color-picker>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/color-picker.tpl.html
// module id = 1981
// module chunks = 1